import { useCallback, useEffect } from "react";
import { useUsersStore } from "@/common/store/storeUsers";
import { apiMain } from "../services";
import { useFetch } from "./useFetch";

interface IUseCachedUser {
  username: string;
}

export const useCachedUser = ({ username }: IUseCachedUser) => {
  const user = useUsersStore(state => state.getUser(username));
  const updateUsers = useUsersStore(state => state.updateUsers);

  const fetchUser = useCallback(() => apiMain.fetchCreatorById(username), [username]);
  const { isLoading, error, data } = useFetch(fetchUser, !user);

  useEffect(() => {
    if (!error && data) {
      updateUsers([data]);
    }
  }, [error, data, updateUsers]);

  return {
    user,
    isLoading,
    error,
  };
};
